import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const LoaderContainer = styled(Box)({
  position: 'absolute',
  outline: 0,
  top: '50%',
  left: '50%',
});

const CircularProgressWrapper = styled(CircularProgress);

export { LoaderContainer, CircularProgressWrapper };
